function extractDate(date) {
  const match = `${date || ''}`.match(/\d{4}-\d{2}-\d{2}/)
  return match ? match[0] : ''
}

function extractHour(date) {
  const match = `${date || ''}`.match(/\d{2}:\d{2}(?::\d{2})?/)

  if (!match) {
    return 0
  }

  return Number(match[0].slice(0, 2))
}

function dateToUTC(date) {
  const [ year, month, day ] = date.split('-').map(x => Number(x))
  return Date.UTC(year, month - 1, day)
}

function isBefore12Hours(date) {
  return extractHour(date) < 12
}

function isAfter12Hours(date) {
  return extractHour(date) >= 12
}

/**
 * Obter a diferença entre dois dias
 */
export default function calcTotalDays(startDate, endDate) {
  const ONE_DAY = 86400000

  const pureStartDate = extractDate(startDate)
  const pureEndDate = extractDate(endDate)

  if (!pureStartDate || !pureEndDate) {
    return 0
  }

  const ds = dateToUTC(pureStartDate)
  const de = dateToUTC(pureEndDate)

  const diffDate = de - ds

  var total = diffDate / ONE_DAY + 1

  if (isAfter12Hours(startDate)) {
    total = total - 1
  }
  if (isBefore12Hours(endDate)) {
    total = total - 1
  }

  return total
}
